import { type ComponentPropsWithRef } from 'react';

import type { VBaseTableData } from '../VBaseTable';
import VInnerTable from './VInnerTable';
import { VTableContextProvider } from './context';
import type { VTableProps } from './type';

const VTable = <T extends VBaseTableData>({
  ref,

  columnSorter,
  columnFilter,

  setRowActivated,
  setRowChecked,
  setRowRemovable,
  setRowSelected,

  onAllRowCheckedChange,
  onColumnSorterChange,
  onColumnFilterChange,
  onRemove,
  onRowActivatedChange,
  onRowCheckedChange,

  ...rest
}: VTableProps<T> &
  Omit<
    ComponentPropsWithRef<'div'>,
    'onClick' | 'onDoubleClick' | 'onScrollEnd'
  >) => {
  return (
    <VTableContextProvider
      columnFilter={columnFilter}
      columnSorter={columnSorter}
      setRowActivated={setRowActivated}
      setRowChecked={setRowChecked}
      setRowRemovable={setRowRemovable}
      setRowSelected={setRowSelected}
      onRowActivatedChange={onRowActivatedChange}
      onRowCheckedChange={onRowCheckedChange}
      onColumnFilterChange={onColumnFilterChange}
      onColumnSorterChange={onColumnSorterChange}
      onRemove={onRemove}
      onAllRowCheckedChange={onAllRowCheckedChange}
    >
      <VInnerTable ref={ref} {...rest} />
    </VTableContextProvider>
  );
};

export default VTable;
